export const BREAKPOINT_SMALL = 576;
export const BREAKPOINT_MEDIUM = 768;
export const BREAKPOINT_LARGE = 1024;
export const BREAKPOINT_EXTRA_LARGE = 1440;
